export default {
  name: "AppHeader",
  created() {
    this.loginDetails = localStorage.getItem("currentUser");
    if (
      this.loginDetails != "null" &&
      this.loginDetails != null &&
      this.loginDetails != "" &&
      this.loginDetails != "[object Object]"
    ) {
      this.loginDetails = JSON.parse(this.loginDetails);
    }
    this.GetConfig();
  },
  data() {
    return {
      loginDetails: null,
      active: 1,
      Tog: "navbar-toggle",
      result: "",
      url: "",
      // NavBar: 'navbar navbar-main navbar-expand-lg navbar-transparent  py-2',
    };
  },

  methods: {
    // $http.GetConfig
    GetConfig() {
      this.$http.GetConfig().then((response) => {
        this.url = response.data;
      });
    },

    link(url) {
      window.location.href = url;
    },

    Poupup() {
      this.$message({
        type: "error",
        message:
          "المهمة قيد التنفيذ والتطوير من قبل ادارة النظام , الرجاء المحاولة في وقت لاحق",
      });
    },

    logout() {
      localStorage.removeItem("currentUser");
      document.cookie.split(";").forEach(function (c) {
        document.cookie = c
          .replace(/^ +/, "")
          .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
      });
      this.$blockUI.Start();
      this.$http
        .Logout()
        .then(() => {
          this.$blockUI.Stop();
          window.location.href = "/";
        })
        .catch((err) => {
          this.$blockUI.Stop();
          console.error(err);
        });
    },

    href(url) {
      this.$router.push(url);
    },
    //navbar-toggle toggled
    IsTogled() {
      if (this.Tog == "navbar-toggle toggled") {
        this.Tog = "navbar-toggle";
      } else {
        this.Tog = "navbar-toggle toggled";
      }
    },
    OpenMenuByToggle() {
      var root = document.getElementsByTagName("html")[0]; // '0' to assign the first (and only `HTML` tag)
      if (root.getAttribute("class") == "perfect-scrollbar-on") {
        root.setAttribute("class", "perfect-scrollbar-on nav-open");
      } else {
        root.setAttribute("class", "perfect-scrollbar-on");
      }
    },
  },
};
